import RestApiUtils from './RestApiUtils'

const sessions = {
  post: (context, callback) => {
    let postResource = RestApiUtils.getServerUrl(context) + '/api/pub/session'
    console.log('-> POST', postResource)

    let headers = new Headers();
    headers.append('Accept', 'application/json')
    headers.append('Content-Type', 'application/json')

    let body = {}
    let params = new URLSearchParams(window.location.search)
    let appCode = params.get('appcode')
    body.appCode = appCode

    fetch(postResource, {
      method: 'post',
      headers: headers,
      body: JSON.stringify(body)
    })
    .then((response) => {
      return response.json()
    })
    .then((json) => {
      console.log('<- POST', postResource, json);
      callback(json)
    })
  },

  /*
  delete: (context, callback) => {
    let deleteResource = RestApiUtils.getServerUrl(context) + '/api/pub/session'
    console.log('-> DELETE', deleteResource)

    let headers = new Headers();
    headers.append('Accept', 'application/json')
    headers.append('Content-Type', 'application/json')

    fetch(deleteResource, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      return response.json()
    })
    .then((json) => {
      console.log('<- DELETE', deleteResource, json);
      callback(json)
    })
  }
  */
}

export default sessions
